import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { FormHelperService } from '../../../helpers/form-helper.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertyInformationSectionComponent } from '../property-information-section/property-information-section.component';

@Component({
    selector: 'property-features-section',
    templateUrl: './property-features-section.component.html',
    styleUrls: ['./property-features-section.component.scss']
})
export class PropertyFeaturesSectionComponent
    extends PropertyInformationSectionComponent
    implements OnInit, OnDestroy {

    @ViewChild('propertyFeaturesSectionForm')
    propertyFeaturesSectionForm: NgForm;

    constructor(
        route: ActivatedRoute,
        draftFacade: DraftFacade,
        changeDetectorRef: ChangeDetectorRef,
        formHelperService: FormHelperService
    ) {
        super(route, draftFacade, changeDetectorRef, formHelperService);
    }

    isValid(): boolean {
        this.formHelperService.validate(this.propertyFeaturesSectionForm);
        return this.formValidationWhenDisabled(true, this.propertyFeaturesSectionForm);
    }

    dirty(): boolean {
        return this.propertyFeaturesSectionForm.form.dirty;
    }
}
